module.exports = __webpack_public_path__ + "img/product-program-phone-dzjqr.962b4bcb.png";